// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Utilities
import { populatePath, translateDate } from 'common/utils/helpers';

// Enums
import { EngagementReportType } from 'engagementReport/enums/propTypes';
import ProjectStatus from 'project/enums/ProjectStatus';

// Routes
import Routes from 'routes';

const EngagementReportSidebar = ({ engagementReport, projectStatus, projectHubEnabled }) => {
  const params = useParams();
  const { t } = useTranslation();
  const { engagement } = engagementReport.snapshot;
  const { project } = engagement;
  const showProjectHubLink =
    projectHubEnabled &&
    (projectStatus === ProjectStatus.ACTIVE || projectStatus === ProjectStatus.FINISHED);
  const { excludeDuplicates, excludeMissingFingerprints, completedSubmissions } =
    engagement.filters;
  const filtered = excludeDuplicates || excludeMissingFingerprints || completedSubmissions;

  const getFilterNotice = () => {
    const filterNotice = [];

    if (filtered) {
      filterNotice.push(t('engagement_report.filter.subset_submissions'));
      filterNotice.push(t('engagement_report.filter.exclude_duplicate_submissions'));
    }

    if (filterNotice.length === 0) return null;

    return (
      <div className="engagement-report-sidebar__filter-notice">
        {`* ${filterNotice.join(' ')}`}
      </div>
    );
  };

  return (
    <div className="engagement-report-sidebar">
      <div className="engagement-report-sidebar__content">
        <div className="title is-6 is-primary-color engagement-report-sidebar__title">
          {t('engagement_report.title')}
        </div>
        <div>
          {`${t('engagement_report.created')}: ${translateDate(engagementReport.createdAt, t)}`}
        </div>
        <div className="title is-5 is-primary-color engagement-report-sidebar__title">
          {engagement.title}
        </div>
        <div>
          {`${translateDate(engagement.startTime, t)} - ${translateDate(engagement.endTime, t)}`}
        </div>
        <div>{`${engagement.respondedSubmissionsCount} ${t(
          'engagement_report.participants'
        )}`}</div>
        <div className="title is-5 is-primary-color engagement-report-sidebar__title">
          {project.title}
        </div>
        {showProjectHubLink && (
          <div>
            <a
              href={populatePath(Routes.PROJECT, params)}
              className="is-secondary-color engagement-report-sidebar__link"
            >
              {t('engagement.visit_project_hub')}
            </a>
          </div>
        )}
      </div>
      {filtered && getFilterNotice()}
    </div>
  );
};

EngagementReportSidebar.propTypes = {
  engagementReport: EngagementReportType.isRequired,
  projectStatus: PropTypes.string,
  projectHubEnabled: PropTypes.bool.isRequired,
};

EngagementReportSidebar.defaultProps = {
  projectStatus: '',
};

export default EngagementReportSidebar;
